/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Thumbs} from "swiper";

var swiper = new Swiper(".objectswiper-thumbs", {
	spaceBetween: 16,
	slidesPerView: 5,
	freeMode: true,
	watchSlidesProgress: true,
  });
  var swiper2 = new Swiper(".objectswiper", {
	modules: [Navigation, Pagination, Thumbs],
	spaceBetween: 20,
	grabCursor: true,
	autoHeight: true,
	navigation: {
	  nextEl: ".swiper-button-next",
	  prevEl: ".swiper-button-prev",
	},
	thumbs: {
	  swiper: swiper,
	},
  });





